import { render, staticRenderFns } from "./DataMonitoring.vue?vue&type=template&id=6ce89c20&"
import script from "./DataMonitoring.vue?vue&type=script&lang=js&"
export * from "./DataMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports